<h2 [id]="titleId">
  <button #toggle type="button" [attr.aria-label]="title" [attr.aria-controls]="controls || null" [attr.aria-expanded]="expanded" (click)="toggled.emit()">
    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" [class.is-collapsed]="!expanded"><path d="m4 6 4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    {{ title }}
  </button>
</h2>
<div class="ia-record-section-actions"><ng-content></ng-content></div>
